export default {
  get: {
    method: 'post',
    url: '/journey-schedule'
  },
  getLocations: {
    method: 'get',
    url: '/p/journey-schedule/locations'
  },
  confirm: {
    method: 'post',
    url: '/p/journey-schedule/confirm/ID'
  },
  manual: {
    method: 'post',
    url: '/p/journey-schedule/manual'
  },
  setting: {
    get: {
      method: 'get',
      url: '/p/journey-schedule/setting'
    },
    update: {
      method: 'post',
      url: '/p/journey-schedule/setting'
    },
    reset: {
      method: 'post',
      url: '/p/journey/reset'
    }
  }
}
